// client/src/modules/recruiting/routes.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '../../components/ProtectedRoute';
import { lazyWithRetry } from '../../lib/lazyWithRetry';

const RecruitingDashboard = lazyWithRetry(() =>
  import('../../pages/Recruiting/RecruitingDashboard').then(m => ({ default: m.default }))
);

const CandidateList = lazyWithRetry(() =>
  import('../../pages/Recruiting/CandidateList').then(m => ({ default: m.default }))
);

const CandidateDetail = lazyWithRetry(() =>
  import('../../pages/Recruiting/CandidateDetail').then(m => ({ default: m.default }))
);

const JobList = lazyWithRetry(() =>
  import('../../pages/Recruiting/JobList').then(m => ({ default: m.default }))
);

const JobDetail = lazyWithRetry(() =>
  import('../../pages/Recruiting/JobDetail').then(m => ({ default: m.default }))
);

const JobTemplatesList = lazyWithRetry(() =>
  import('../../pages/Recruiting/JobTemplates').then(m => ({ default: m.default }))
);

const TalentPoolsList = lazyWithRetry(() =>
  import('../../pages/Recruiting/TalentPools').then(m => ({ default: m.default }))
);

const TalentPoolDetail = lazyWithRetry(() =>
  import('../../pages/Recruiting/TalentPools/TalentPoolDetail').then(m => ({ default: m.default }))
);

const Pipeline = lazyWithRetry(() =>
  import('../../pages/Recruiting/Pipeline').then(m => ({ default: m.default }))
);

const SequencesList = lazyWithRetry(() =>
  import('../../pages/Recruiting/Sequences').then(m => ({ default: m.default }))
);
const SequenceDetail = lazyWithRetry(() =>
  import('../../pages/Recruiting/Sequences/SequenceDetail').then(m => ({ default: m.default }))
);
const SequenceEnrollments = lazyWithRetry(() =>
  import('../../pages/Recruiting/Sequences/SequenceEnrollments').then(m => ({ default: m.default }))
);

const OutreachAnalytics = lazyWithRetry(() =>
  import('../../pages/Recruiting/OutreachAnalytics').then(m => ({ default: m.default }))
);

const Partners = lazyWithRetry(() =>
  import('../../pages/Recruiting/Partners').then(m => ({ default: m.default }))
);

const PartnerDetail = lazyWithRetry(() =>
  import('../../pages/Recruiting/Partners/PartnerDetail').then(m => ({ default: m.default }))
);

/**
 * Recruiting module routes - relative to /recruiting prefix
 */
export const routes: RouteObject[] = [
  {
    index: true,
    element: <ProtectedRoute><RecruitingDashboard /></ProtectedRoute>,
  },
  {
    path: 'candidates',
    element: <ProtectedRoute><CandidateList /></ProtectedRoute>,
  },
  {
    path: 'candidates/:contactId',
    element: <ProtectedRoute><CandidateDetail /></ProtectedRoute>,
  },
  {
    path: 'jobs',
    element: <ProtectedRoute><JobList /></ProtectedRoute>,
  },
  {
    path: 'jobs/:jobId',
    element: <ProtectedRoute><JobDetail /></ProtectedRoute>,
  },
  {
    path: 'job-templates',
    element: <ProtectedRoute><JobTemplatesList /></ProtectedRoute>,
  },
  {
    path: 'pipeline',
    element: <ProtectedRoute><Pipeline /></ProtectedRoute>,
  },
  {
    path: 'partners',
    element: <ProtectedRoute><Partners /></ProtectedRoute>,
  },
  {
    path: 'partners/:partnerId',
    element: <ProtectedRoute><PartnerDetail /></ProtectedRoute>,
  },
  {
    path: 'talent-pools',
    element: <ProtectedRoute><TalentPoolsList /></ProtectedRoute>,
  },
  {
    path: 'talent-pools/:poolId',
    element: <ProtectedRoute><TalentPoolDetail /></ProtectedRoute>,
  },
  {
    path: 'sequences',
    element: <ProtectedRoute><SequencesList /></ProtectedRoute>,
  },
  {
    path: 'sequences/:sequenceId',
    element: <ProtectedRoute><SequenceDetail /></ProtectedRoute>,
  },
  {
    path: 'sequences/:sequenceId/enrollments',
    element: <ProtectedRoute><SequenceEnrollments /></ProtectedRoute>,
  },
  {
    path: 'outreach-analytics',
    element: <ProtectedRoute><OutreachAnalytics /></ProtectedRoute>,
  },
  {
    path: 'settings',
    element: <Navigate to="/recruiting" replace />,
  },
  {
    path: 'about',
    element: <Navigate to="/recruiting" replace />,
  },
  {
    path: '*',
    element: <Navigate to="/recruiting" replace />,
  },
];
